import { Card, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface AccessStatePageProps {
  title: string;
  description: ReactNode;
}

const AccessStatePage = ({ title, description }: AccessStatePageProps) => (
  <Card sx={{ maxWidth: 720, mx: "auto", px: 4, py: 5, borderRadius: 3 }}>
    <Stack spacing={1.5}>
      <Typography variant='h28'>{title}</Typography>
      <Typography color='text.secondary'>{description}</Typography>
    </Stack>
  </Card>
);

export default AccessStatePage;
